import { Swiper, SwiperSlide } from "swiper/react";
import { Href } from "../../../constants";
import { car2InstagramSlider, InstagramSliderData } from "../../../data/demo/CarDemo2";
import { dynamicImage } from "../../../utils";
import RatioImage from "../../../utils/RatioImage";

const InstagramSlider = () => {
  return (
    <>
      <section className="section-t-lg-space car2-insta-section">
        <Swiper {...car2InstagramSlider} className="car2-insta-slider ratio_square">
          {InstagramSliderData.map((item, index) => (
            <SwiperSlide key={index}>
              <a href={Href} className="insta-img">
                <RatioImage src={dynamicImage(`car2/insta/${item}.jpg`)} alt="i-1" className="bg-img" />
                <div className="insta-overlay">
                  <i className="ri-instagram-line" />
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </>
  );
};

export default InstagramSlider;
